// @ts-nocheck
import Box from '@mui/material/Box';
import DeleteActions from '../DeleteActions/DeleteActions';
import { XGModal } from 'xg-cl';
import * as PropTypes from 'prop-types';

/**
 * Functional React component for rendering a custom delete modal component.
 *
 * @namespace Components
 *
 * @param {Object} props - The component's properties
 * @param {string} [props.id] - The ID for the delete day component.
 * @param {string} [props.isOpenModal] - Boolean value to indicate whether modal is open.
 * @param {Function} [props.onConfirm] - Callback function to handle form submission.
 * @param {Function} [props.onCancel] - Callback function to handle form closing.
 * @param {string} [props.description] - The description for the delete modal.
 * @param {string} [props.title] - The title for the delete modal.
 * @param {boolean} [props.isSubmitting] - Boolean value to indicate whether form is submitting.
 * @param {string} [props.submitText] - Optional text for the destructive action button.
 * @param {string} [props.cancelText] - Optional text for the safe action button.
 * @param {...any} props.rest - Additional props to be spread on the parent element.
 *
 * @returns {JSX.Element} React element representing the delete modal component..
 */

const DeleteModal = ({
  id,
  isOpenModal,
  onConfirm,
  onCancel,
  description,
  title,
  isSubmitting,
  submitText,
  cancelText,
  ...rest
}) => {
  return (
    <XGModal
      id={id}
      allowClosing={false}
      data-testid={id}
      actions={
        <DeleteActions
          onCancel={onCancel}
          onSubmit={onConfirm}
          isSubmitting={isSubmitting}
          submitText={submitText}
          cancelText={cancelText}
        />
      }
      dismissable={false}
      open={isOpenModal}
      title={title}
      labelledby={title}
      maxWidth='lg'
      scroll='body'
      onClose={onCancel}
      {...rest}
    >
      <Box className='create-trip-header' sx={{ maxWidth: '400px' }}>
        <p className='text-md-regular'>{description}</p>
      </Box>
    </XGModal>
  );
};

DeleteModal.propTypes = {
  id: PropTypes.string.isRequired,
  isOpenModal: PropTypes.bool,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  description: PropTypes.string,
  title: PropTypes.string,
  isSubmitting: PropTypes.bool,
  submitText: PropTypes.string,
  cancelText: PropTypes.string
};

export default DeleteModal;
